import { IDotDangKyChuyenNganh } from "../../model/respone/dang-ky-chuyen-nganh/IDotDangKyChuyenNganh";
import {
  IDangKyChuyenNganhSinhVien,
  INguyenVongSinhVienRequest,
} from "../../model/respone/dang-ky-chuyen-nganh/IDangKyChuyenNganhSinhVien";
import { IDeleteKetQuaDangKyRequest } from "../../model/request/dang-ky-chuyen-nganh/IDeleteKetQuaDangKyRequest";
import { IThietLapDotDangKyChuyenNganh } from "../../model/respone/dang-ky-chuyen-nganh/IThietLapDotDangKyChuyenNganh";
import { apiClient } from "../apiClient";

const DOT_API = "dot-dang-ky-chuyen-nganh";
const THIET_LAP_API = "dot-dang-ky-chuyen-nganh-thiet-lap";
const SINH_VIEN_API = "dot-dang-ky-chuyen-nganh-sinh-vien";
const KET_QUA_XET_API = "dot-dang-ky-chuyen-nganh-ket-qua-xet";

export const dotDangKyChuyenNganhApi = {
  SelectAll: () => apiClient.get(DOT_API),
  Insert: (payload: IDotDangKyChuyenNganh) => apiClient.post(DOT_API, payload),
  Update: (payload: IDotDangKyChuyenNganh) => apiClient.put(DOT_API, payload),
  Delete: (id: number) => apiClient.delete(`${DOT_API}/${id}`),
};

export const thietLapDotDangKyChuyenNganhApi = {
  SelectByDot: (dotId: number) => apiClient.get(`${THIET_LAP_API}/by-dot/${dotId}`),
  Submit: (dotId: number, payload: IThietLapDotDangKyChuyenNganh[]) =>
    apiClient.post(`${THIET_LAP_API}/submit/${dotId}`, payload),
};

export const sinhVienDangKyChuyenNganhApi = {
  SelectByDot: (dotId: number) => apiClient.get(`${SINH_VIEN_API}/by-dot/${dotId}`),
  SelectByDotSinhVien: (dotId: number, idSv: string) =>
    apiClient.get(`${SINH_VIEN_API}/by-dot-sv/${dotId}/${encodeURIComponent(idSv)}`),
  SubmitNguyenVong: (payload: INguyenVongSinhVienRequest) =>
    apiClient.post(`${SINH_VIEN_API}/submit-nguyen-vong`, payload),
  DeleteKetQuaDangKy: (payload: IDeleteKetQuaDangKyRequest) =>
    apiClient.post(`${SINH_VIEN_API}/delete-ket-qua-dang-ky`, payload),
};

export const ketQuaXetChuyenNganhApi = {
  SelectByDot: (dotId: number) => apiClient.get(`${KET_QUA_XET_API}/by-dot/${dotId}`),
  XetTuDong: (dotId: number) => apiClient.post(`${KET_QUA_XET_API}/xet-tu-dong/${dotId}`, {}),
};
